import { render, staticRenderFns } from "./MoreMenuItem.vue?vue&type=template&id=86a3a64e"
import script from "./MoreMenuItem.vue?vue&type=script&lang=js"
export * from "./MoreMenuItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports